import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import usePrevious from "../hooks/usePrevious";
import {unsetRedirectUrl} from "../state/miscellaneous/miscellaneousActions";
import {redirectUrlSelector} from "../state/miscellaneous/miscellaneousSelectors";
import {clearPendingRequests} from "../state/pending-request/pendingRequestActions";
import {flushSpinner} from "../state/spinner/spinnerActions";

const AppDomain = ({children}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const redirectUrl = useSelector(redirectUrlSelector);

  // Handle redirect logic when redirectUrl is set in Redux state
  useEffect(() => {
    if (redirectUrl) {
      navigate(redirectUrl);
      dispatch(unsetRedirectUrl()); // Clear redirect after navigation
    }
  }, [redirectUrl, dispatch, navigate]);

  // Track route changes to clear pending requests and spinner
  const location = useLocation().pathname;
  const prevLocation = usePrevious(location);
  if (prevLocation && prevLocation !== location) {
    dispatch(clearPendingRequests()); // Clear any pending API requests
    dispatch(flushSpinner()); // Hide any loading spinner
  }

  return children;
};

export default AppDomain;
